import { Link, createFileRoute, notFound } from '@tanstack/react-router';
import { CalendarOffIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { requireResourcesFeature } from '@/features/resources/guard';
import { parseHeatmapSearch } from '@/features/resources/heatmap/heatmap-search';
import { PersonResources } from '@/features/resources/heatmap/person-resources';
import { resourceTexts } from '@/features/resources/texts';

const texts = resourceTexts.myResources;

/** RES-12: own utilization for every internal user (externals: not found). */
export const Route = createFileRoute('/_app/my-resources')({
  validateSearch: (raw: Record<string, unknown>) => parseHeatmapSearch(raw),
  beforeLoad: async ({ context }) => {
    if (context.me.user.userType !== 'internal') throw notFound();
    await requireResourcesFeature(context.queryClient);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold">{texts.title}</h1>
          <p className="text-muted-foreground mt-1 text-sm">{texts.intro}</p>
        </div>
        <Button variant="outline" asChild>
          <Link to="/absences">
            <CalendarOffIcon />
            {texts.absences}
          </Link>
        </Button>
      </div>
      <PersonResources
        target="me"
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: next, replace: true });
        }}
      />
    </div>
  );
}
